// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerPopup.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');

  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('./Izenda.ReportExportIframePopupActions');
  var ReportsConstants = require('logic/data/Izenda.ReportsConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');

  var ReportExportIframePopup = (React.createClass({

    render: function () {
      const { onClosing } = this.props;
      const localization =  this.props.localization;
      const iconCopyTooltip = document.queryCommandSupported("copy")
        ? localization.getText('REPORTS_CONSTANTS_IFRAME_EXPORT_POPUP_LABEL_COPY_PASSWORD_LINK')
        : localization.getText('REPORTS_CONSTANTS_IFRAME_EXPORT_POPUP_LABEL_COPY_PASTE');

      return (
        <Popup visible type="none" onClosing={onClosing} autoClose={false} sizeClass="modal-md">
        <Popup.Header title={ReportsConstants.REPORT_EXPORT_IFRAME_POPUP.popupTitle} />
        <Popup.Body>
          <GridLayout className='izenda-IframeExportPopupWrapper'>
            <GridLayout.Row>
              <div className='izenda-ExportIframeLinkCustom u_inlineBlock'>
                <Input className='form-control u_inlineBlock'
                        id='izenda-ExportIframeLinkCustom'
                        value={`<iframe height="800" width="1200" src="${this.props.embedLink}"></iframe>`} disabled/>
                <i className='icon-copy u-posAbsolute izenda-IconCopyClipBoard'
                    title={iconCopyTooltip}
                    onClick={this.props.onCopyPasswordLink} />
              </div>
            </GridLayout.Row>
          </GridLayout>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="accept">{this.props.localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
        );
    }
  }));

  module.exports = connect(actions)(ReportExportIframePopup);
})();


// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.ReportExportIframePopup.js